import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../project.service';
import { Project, ProjectType } from '../project';
import { Router } from '@angular/router';
import { KnaufPalettes } from '../knauf-palettes.enum';
import { LayerHistoryService } from '../layer-history.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { faFileUpload, faHandPointer } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-start-project',
  templateUrl: './start-project.component.html',
  styleUrls: ['./start-project.component.sass']
})
export class StartProjectComponent implements OnInit {

  title: string = "Wybierz dom z bazy gotowych projektów lub wgraj zdjęcie swojego domu";
  next: string = "/choose-project"
  project: Project
  faFileUpload = faFileUpload;
  faHandPointer = faHandPointer;

  constructor(private projectService: ProjectService, private router: Router, private layerHistory: LayerHistoryService, private deviceService: DeviceDetectorService) { }

  ngOnInit() {
    this.layerHistory.clear();
    this.projectService.resetProject();
    this.project = this.projectService.getProject();
  }

  loadFile(event) {
    var projectService = this.projectService;
    var router = this.router;
    var reader = new FileReader();
    var width = this.deviceService.isMobile() ? document.body.offsetWidth : 1200;
    var loading: HTMLDivElement = <HTMLDivElement>document.getElementById('loading');
    loading.style.display = 'flex';
    reader.onload = function (e: any) {
      var img: HTMLImageElement = document.createElement('img');
      img.src = e.target.result;
      img.onload = function (event) {
        var canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = width;
        canvas.height = width / img.width * img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
        projectService.setProjectType(ProjectType.user);
        projectService.setOrgImageFile(canvas.toDataURL('image/jpeg'));
        projectService.setProjectImageFile(canvas.toDataURL('image/jpeg'));
        projectService.setKnaufPalette(KnaufPalettes.MiejskiSzyk);
        router.navigate(['/user-start-project']);
      };
    }

    reader.readAsDataURL(event[0]);
  };
}
